/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckinsForDriverUpdate } from '../../models/checkins-for-driver-update';
import { KeyType } from '../../models/key-type';
import { PutDriverInformation } from '../../models/put-driver-information';

export interface PutConsignerDriverDetails$Params {
  organizationSiteKey: KeyType;
  checkinKey: KeyType;
      body: PutDriverInformation
}

export function putConsignerDriverDetails(http: HttpClient, rootUrl: string, params: PutConsignerDriverDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckinsForDriverUpdate>> {
  const rb = new RequestBuilder(rootUrl, putConsignerDriverDetails.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckinsForDriverUpdate>;
    })
  );
}

putConsignerDriverDetails.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/driver-details';
